import { ArtistList } from './ArtistList';
import WContainer from '../WContainer/WContainer';
import { ComponentProps } from 'react';

export const ArtistListBox = (props: ComponentProps<typeof ArtistList>) => {
  return (
    <WContainer extraClasses="tw-w-1/4">
      <ArtistList {...props} />
    </WContainer>
  );
};
